module.exports = __webpack_public_path__ + "static/media/ClientTemplate.fedde3e2.csv";